angular.module('tasks')
    .controller('TaskStatusChangeDialogController', function ($timeout, $scope, $rootScope, $filter, $uibModalInstance, data, toastr, Task, TaskStatus) {
        this.$onInit = () => {
            this.task = data;
            this.item = {
                id: this.task.id,
                status: this.task.done === true ? 'SCHEDULED' : 'DONE_POSITIVE'
            };
            TaskStatus.list().$promise.then(items => this.statuses = items);
        }

        this.cancel = () => $uibModalInstance.dismiss('Canceled');
        this.save = () => {
            return Task.updateStatus(this.item).$promise
                .then(() => {
                    $rootScope.$broadcast('task.updated');
                    $rootScope.$broadcast('document.comments.reload', data.id);
                    toastr.success("Zapisano status");
                    $uibModalInstance.close();
                })
        };

        this.onStatusChanged = $item => {
            this.item.customRealEndTime = false;
            delete this.item.realEndTime;
            if(!['DONE_POSITIVE', 'DONE_NEGATIVE'].includes(this.item.status)) {
                delete this.item.comment;
            }
        }
        this.onCustomRealEndTimeChanged = () => {
            delete this.item.realEndTime;
        }
        this.setRealEndTimeFromTask = () => {
            this.item.realEndTime = this.task.endTime
        }
    })
